module.exports = __webpack_public_path__ + "static/media/bground1.330a82b5.png";